import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-2',
    button: 'w-full',
    sbpContent: 'gap-2',
    sbpLabel: 'heading-m-regular lowercase',
    cardButton:
      'border-primary text-on-base enabled:hover:border-accent enabled:hover:text-accent w-full border bg-transparent!'
  }
});
